export class CreatePassword {
  public UserName?: string;
  public EmailAddress?: string;
  public EncNewPassword?: string;
  public UniqueTokenId?: string;
  public ResetDateTime?: string;
}
